import { useEffect, useRef, useState } from 'react';
import { useBloco, useParceiros } from '../content';

function PartnerItem({ name, logo, caption, scale }) {
  const [failed, setFailed] = useState(false);
  const showImg = logo && !failed;
  const scaleStyle = scale ? { transform: `scale(${scale})` } : undefined;
  return (
    <div className="gal-item" title={name}>
      {showImg ? (
        caption ? (
          <div className="partner-stack">
            <img
              src={logo}
              alt={name}
              className="partner-logo"
              style={scaleStyle}
              loading="lazy"
              decoding="async"
              onError={() => setFailed(true)}
            />
            <span className="partner-caption">{caption}</span>
          </div>
        ) : (
          <img
            src={logo}
            alt={name}
            className="partner-logo"
            style={scaleStyle}
            loading="lazy"
            decoding="async"
            onError={() => setFailed(true)}
          />
        )
      ) : (
        <>
          <span className="company-dot" />
          <div className="company-name">{name}</div>
        </>
      )}
    </div>
  );
}

export default function PartnersCarousel() {
  const trackRef = useRef(null);
  const txt = useBloco('home.partners');
  const parceiros = useParceiros();

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    // Clonar itens para o loop infinito.
    // Os clones são marcados para poderem ser removidos: sem isso,
    // quando a lista muda (edição no painel), os clones antigos
    // permaneceriam e o carrossel exibiria itens repetidos.
    const clones = [];
    [...track.children].forEach((el) => {
      if (el.dataset.clone === '1') return;
      const clone = el.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.dataset.clone = '1';
      track.appendChild(clone);
      clones.push(clone);
    });

    let pos = 0;
    let paused = false;
    let rafId;
    const speed = 0.5;

    const getSetWidth = () => track.scrollWidth / 2;

    const loop = () => {
      if (!paused) {
        pos -= speed;
        if (Math.abs(pos) >= getSetWidth()) pos = 0;
        track.style.transform = `translateX(${pos}px)`;
      }
      rafId = requestAnimationFrame(loop);
    };

    rafId = requestAnimationFrame(loop);

    // Listeners guardados em variáveis para poderem ser removidos.
    // Funções anônimas em addEventListener não têm como ser
    // desregistradas, e o efeito agora roda mais de uma vez.
    const pausar = () => { paused = true; };
    const retomar = () => { paused = false; };
    const aoTrocarAba = () => {
      cancelAnimationFrame(rafId);
      if (!document.hidden) rafId = requestAnimationFrame(loop);
    };

    const section = track.parentElement?.parentElement;
    section?.addEventListener('mouseenter', pausar);
    section?.addEventListener('mouseleave', retomar);
    document.addEventListener('visibilitychange', aoTrocarAba);

    return () => {
      cancelAnimationFrame(rafId);
      section?.removeEventListener('mouseenter', pausar);
      section?.removeEventListener('mouseleave', retomar);
      document.removeEventListener('visibilitychange', aoTrocarAba);
      clones.forEach((c) => c.remove());
      track.style.transform = '';
    };
  }, [parceiros]);

  return (
    <div className="gallery-section">
      <h3>{txt.heading} <em>{txt.headingEm}</em></h3>
      <div style={{ overflow: 'hidden' }}>
        <div className="gallery-track" ref={trackRef}>
          {parceiros.map((p, i) => (
            <PartnerItem key={p.logo || p.name || i} {...p} />
          ))}
        </div>
      </div>
    </div>
  );
}
